const _excluded = ["title", "titleId"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 113 114",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2e3a47;}")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Nuevos i\u0301conos 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M82.21,9.28H27.79a13.59,13.59,0,0,0-12,20.4L40.31,72.07a8.35,8.35,0,0,1,1.08,4.08V93.62a13.61,13.61,0,0,0,27.21,0V76.15a8.36,8.36,0,0,1,1.09-4.08L94.18,29.68a13.61,13.61,0,0,0-12-20.4Zm7,17.68L65,69.13a14.48,14.48,0,0,0-1.8,6.81V93.62a8.16,8.16,0,1,1-16.32,0V76.15a14.5,14.5,0,0,0-1.8-7L20.55,27a7.87,7.87,0,0,1,0-8.16,8.07,8.07,0,0,1,3.05-3.06,8,8,0,0,1,4.19-1H82.21a8,8,0,0,1,7,4.08A7.84,7.84,0,0,1,89.44,27Z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.49aad10fdae1edece67cef5ff5ee837d.svg";
export { ForwardRef as ReactComponent };